module.exports = __webpack_public_path__ + "img/braga.c70f0e48.jpg";